module.exports = __webpack_public_path__ + "img/program-day.d6741cf2.svg";